module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAA0ElEQVRIS+2TPQ4BURRGzxssQCERCiFRKlQaa5gN6MSM0GgsQKmk1FqLwkIkSpVE5j2uZDJUjBfzU82tv3vy5eReZTxcEYakMEpxUNpjI8IiBR5KsS2AyUxm41DGdIxD07qbsBSF+ykfNrQGRcFgwg7w8wXKCocTDZu2GtbAKLahzKnrgLMNMC7zdlgA/1aZocMZVaPZ21QT6AGtfA/bptkrk//r3aZ0S/fwnaxGoA+0vzoMfAY8OFrRfoTCsymAiVRm41B8KhhqiapFy5cy1yeQXICAk3wYHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.png
// module id = U+2z
// module chunks = 0